// SourceChoiceStep.tsx — step 'source-choice' del onboarding.
// Qué hace: ofrece las tres vías para aportar info de marca (scan web, manual, doc).
// Qué exporta: SourceChoiceStep.
// Quién lo usa: CreateWorkspaceModal.

import { WizardStep } from '../types';
import { SourceChoiceGrid, SourceChoiceBtn, SourceIcon, SourceLabel, SourceDesc } from '../styled';

interface Props {
  user: (text: string) => void;
  novah: (text: string) => void;
  pushStep: (next: WizardStep) => void;
}

export function SourceChoiceStep({ user, novah, pushStep }: Props) {
  return (
    <SourceChoiceGrid>
      <SourceChoiceBtn onClick={() => {
        user('I have a website');
        novah("Paste your website URL and I'll extract everything automatically.");
        pushStep('url-input');
      }}>
        <SourceIcon>🌐</SourceIcon>
        <div><SourceLabel>Scan my website</SourceLabel><br /><SourceDesc>I'll extract your brand info, logo, and images automatically</SourceDesc></div>
      </SourceChoiceBtn>
      <SourceChoiceBtn onClick={() => {
        user("I'll enter it manually");
        novah("No problem! What's your brand name?");
        pushStep('manual-name');
      }}>
        <SourceIcon>✏️</SourceIcon>
        <div><SourceLabel>Enter manually</SourceLabel><br /><SourceDesc>Type your brand name and upload a logo</SourceDesc></div>
      </SourceChoiceBtn>
      <SourceChoiceBtn onClick={() => {
        user('I have a document');
        novah("Great! Upload a PDF, DOCX, or TXT file with your brand info and I'll analyze it.");
        pushStep('document-upload');
      }}>
        <SourceIcon>📄</SourceIcon>
        <div><SourceLabel>Upload a document</SourceLabel><br /><SourceDesc>PDF, brand guide, or any file with your brand info</SourceDesc></div>
      </SourceChoiceBtn>
    </SourceChoiceGrid>
  );
}
